import React, { FC, memo } from 'react';
import { ConnectionModel, isInitialPolicyModeUndefined } from '../../connection.model';
import './policy-summary-modal.scss';
import GenericModal from '../../../../shared/generic-modal/generic-modal';
import { PolicySummary } from '../../../policy-summary/policy-summary';
import { useNavigate } from 'src/utils/use-navigate';
import { useStores } from '../../../../store';
import PolicyInfoHeader from '../policy-info-header/policy-info-header';
import { EventType } from '../../../../../dtos/analytics.dto';

interface PolicySummaryModalProps {
    connection: ConnectionModel;
    isOpen: boolean;
    onClose: () => void;
}

const PolicySummaryModal: FC<PolicySummaryModalProps> = memo(({connection, isOpen, onClose}) => {

    const { customerStore } = useStores();

    const navigate = useNavigate();

    const handleViewPolicy = async () => {
        customerStore.sendGeneralEvent(
            EventType.LinkClicked,
            {
                button: 'viewPolicy',
                location: 'policySummaryModal'
            }
        );
        if (isInitialPolicyModeUndefined(connection)) {
            await customerStore.setCustomPolicy([connection.id]);
        }
        navigate(`../${connection.id}/protection/version/${connection.policyExternalId}/geo-filtering`);
    };

    return (
            <GenericModal title="Policy Summary"
                          subtitle={connection.connectionName || connection.circuitId}
                          width={816}
                          open={isOpen}
                          onCancel={onClose}
                          wrapClassName="ecm-policy-summary"
                          body={<PolicySummary connectionId={connection.id}
                                               externalId={connection.policyExternalId}
                                               serviceLevel={connection.serviceLevel}
                                               comments={connection.policyVersionComments}>
                              <PolicyInfoHeader connection={connection} />
                          </PolicySummary>}
                          actionButtons={[{
                              text: 'View Policy',
                              onClick: () => handleViewPolicy(),
                              disabled: connection.isInAnalysis,
                              disableReason: '',
                              className: 'primary-btn'
                          }]}/>
    );
});

export default PolicySummaryModal;